import { render, staticRenderFns } from "./StatementsSearch.vue?vue&type=template&id=bb3245c2"
import script from "./StatementsSearch.vue?vue&type=script&lang=js"
export * from "./StatementsSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports